import CustomerOrderDetailsScreen from '@screens/customer/order/details'

export default function CustomerOrderDetailsPage() {
  return <CustomerOrderDetailsScreen />
}
